







































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import BriocheImageTag from 'frontend/components/BriocheImageTag.vue';

import { MobileGetter } from 'frontend/types';
import { GeneralPathCourse } from 'frontend/types/courses';

@Component({
  components: {
    BriocheImageTag,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class GeneralPathCourses extends Vue {
  @Prop({ type: Array, required: true }) readonly courses!: GeneralPathCourse[];
  @Prop({ type: Boolean, required: false }) readonly isMathcounts!: boolean;
  private isMobile!: MobileGetter;

  private courseIsExpanded: Record<string, boolean> = {};

  private get mobile(): boolean {
    return this.isMobile(this.$mq);
  }

  private toggleCourse(slug: string): void {
    const topicListWrapper = (this.$refs[`topicListWrapper-${slug}`] as HTMLElement[])[0];
    const topicList = (this.$refs[`topicList-${slug}`] as HTMLElement[])[0];

    Vue.set(this.courseIsExpanded, slug, !this.courseIsExpanded[slug]);

    if (this.courseIsExpanded[slug]) {
      topicListWrapper.style.height = `${topicList.clientHeight}px`;
    } else {
      topicListWrapper.style.height = '0px';
    }
  }
}
